// С чем сравнивать выручку периода (тенденция на «Выручке»). Выбирается по выбранному периоду, а не по числу дней:
// у ресторана выручка сильно зависит от дня недели, поэтому дни сравниваются с тем же днём прошлой недели.
// «Сегодня» — до того же часа (untilNow: прошлый день режется по часу закрытия заказа на бэкенде).
import { endOfMonth, getDaysInMonth, setDate, startOfMonth, subDays, subMonths } from 'date-fns';
import { parseDay, toDayString } from '../../../utils/periods';

// «к прошлой пятнице» — по дню недели (getDay: 0 — воскресенье)
const WEEKDAY_DATIVE = ['прошлому воскресенью', 'прошлому понедельнику', 'прошлому вторнику', 'прошлой среде',
  'прошлому четвергу', 'прошлой пятнице', 'прошлой субботе'];

const range = (from, to) => ({ from: toDayString(from), to: toDayString(to) });

/**
 * periodKey — ключ периода из PeriodSelector (today, yesterday, week, month, lastWeek, lastMonth) или 'day' —
 * разовый день из ссылки (/metrics?day=). → { from, to, untilNow, label } или null (сравнивать не с чем).
 */
export function comparisonFor(periodKey, dateRange) {
  if (!dateRange?.from || !dateRange?.to) return null;
  const from = parseDay(dateRange.from);
  const to = parseDay(dateRange.to);
  const weekday = WEEKDAY_DATIVE[to.getDay()];

  switch (periodKey) {
    case 'today':
      return { ...range(subDays(to, 7), subDays(to, 7)), untilNow: true, label: `к ${weekday} на это время` };
    case 'yesterday':
    case 'day':
      return { ...range(subDays(to, 7), subDays(to, 7)), untilNow: false, label: `к ${weekday}` };
    case 'week':
      return { ...range(subDays(from, 7), subDays(to, 7)), untilNow: false, label: 'к прошлой неделе' };
    case 'month': {
      // С 1-го прошлого месяца по то же число (не дальше конца прошлого месяца)
      const prevFrom = startOfMonth(subMonths(from, 1));
      return { ...range(prevFrom, setDate(prevFrom, Math.min(to.getDate(), getDaysInMonth(prevFrom)))), untilNow: false, label: 'к прошлому месяцу' };
    }
    case 'lastWeek':
      return { ...range(subDays(from, 7), subDays(to, 7)), untilNow: false, label: 'к позапрошлой неделе' };
    case 'lastMonth': {
      const prevFrom = startOfMonth(subMonths(from, 1));
      return { ...range(prevFrom, endOfMonth(prevFrom)), untilNow: false, label: 'к позапрошлому месяцу' };
    }
    default:
      return null;
  }
}

// Ключ данных сравнения: данные одного периода не смешиваются с другим (при смене периода — без мелькания)
export const comparisonKey = (comparison) => (comparison ? `${comparison.from}|${comparison.to}|${comparison.untilNow ? 1 : 0}` : null);
